import { Grid2 as Grid } from "@mui/material"
import Button from "@mui/material/Button"
import { Formik } from "formik"
import { useMemo } from "react"
import * as yup from "yup"
import { transformErrorForForm } from "../../utils/utils"
import { FormInDialogProps } from "../DialogForm"
import { useTranslation } from "react-i18next"
import { ACVocabolario, ACVocabolarioMulti } from "./autocompletes"

export default function UnificaVocaboliForm({
  save,
  ref,
  item,
}: FormInDialogProps<string>) {
  const { t } = useTranslation()
  const initialValues = useMemo(() => {
    return {
      vocabolario_da_mantenere: "",
      vocaboli_da_eliminare: [],
    }
  }, [])

  const schema = useMemo(
    () =>
      yup.object().shape({
        vocabolario_da_mantenere: yup.string().required().label(t("vocabolario.vocabolario_da_mantenere")),
        vocaboli_da_eliminare: yup.array().of(yup.string()).required().label(t("vocabolario.vocaboli_da_eliminare")),
      }),
    [t]
  )

  return (
    <Formik
      validationSchema={schema}
      initialValues={initialValues}
      enableReinitialize
      onSubmit={(values, formikBag) => {
        return save(values as any).catch((e) => {
          const localError = transformErrorForForm(e)
          formikBag.setErrors(localError)
        })
      }}
    >
      {({ handleSubmit, values, setFieldValue }) => {
        return (
          <form onSubmit={handleSubmit} noValidate>
            <Grid container spacing={1} sx={{ py: 2 }}>
              <Grid size={12}>
                <ACVocabolario
                  label={t("vocabolario.vocabolario_da_mantenere")}
                  fullWidth
                  vocabolario={item ?? ""}
                  margin="dense"
                  variant="outlined"
                  value={Number(values.vocabolario_da_mantenere)}
                  onChange={(value) => {
                    setFieldValue("vocabolario_da_mantenere", value)
                  }}
                />
              </Grid>
              <Grid size={12}>
                <ACVocabolarioMulti
                  label={t("vocabolario.vocaboli_da_eliminare")}
                  fullWidth
                  excludeId={Number(values.vocabolario_da_mantenere)}
                  margin="dense"
                  variant="outlined"
                  value={values.vocaboli_da_eliminare || []}
                  onChange={(value) => {
                    setFieldValue("vocaboli_da_eliminare", value)
                  }}
                  vocabolario={item ?? ""}
                />
              </Grid>
            </Grid>

            <Button
              disabled={!values.vocabolario_da_mantenere || values.vocaboli_da_eliminare.length === 0}
              ref={ref}
              type="submit"
              color="primary"
              sx={{ display: "none" }}
            ></Button>
          </form>
        )
      }}
    </Formik>
  )
}
